export default {
    wbl_category_column: {
        column_name: "Tên cột",
        column_type: "Kiểu dữ liệu",
        order_value: "Vị trí"
      }
}